/** Independent logistics RFQ entry routes (website). */
export const LOGISTICS_RFQ_ROUTES = {
  selection: '/logistics/rfq',
  generic: '/logistics/rfq/generic',
  businessRelocation: '/logistics/rfq/business-relocation',
  exhibitionLogistics: '/logistics/rfq/exhibition-logistics',
};

export const LOGISTICS_RFQ_FORM_OPTIONS = {
  generic: {
    id: 'generic',
    title: 'Generic Logistics Services',
    description:
      'Standard freight and transport — share shipment details and receive quotes from verified providers.',
    route: LOGISTICS_RFQ_ROUTES.generic,
    icon: '📦',
  },
  businessRelocation: {
    id: 'business-relocation',
    title: 'Business Relocation',
    description: 'Office moves, plant relocations, and multi-location transfers with tailored planning.',
    route: LOGISTICS_RFQ_ROUTES.businessRelocation,
    icon: '🏢',
  },
  exhibitionLogistics: {
    id: 'exhibition-logistics',
    title: 'Exhibition Logistics',
    description: 'Trade show booth material, event freight, and time-critical exhibition deliveries.',
    route: LOGISTICS_RFQ_ROUTES.exhibitionLogistics,
    icon: '🎪',
  },
};

export function buildLogisticsRfqFormPath(route, companyId) {
  if (companyId == null || companyId === '') return route;
  const n = Number(companyId);
  if (!Number.isFinite(n) || n <= 0) return route;
  return `${route}?companyId=${n}`;
}
